/** Fonds de carte gratuits (aucune clé). Attribution obligatoire pour les fonds à tuiles. */
export interface Basemap {
  id: string;
  label: string;
  url: string; // vide = pas de tuiles (fond uni)
  attribution: string;
  maxZoom: number;
}

export const DEFAULT_BASEMAP = 'flat';

export const BASEMAPS: Basemap[] = [
  { id: 'flat', label: 'Aplat', url: '', attribution: '', maxZoom: 18 },
  {
    // OSM France : libellés en français (villes, régions), gratuit sans clé.
    id: 'plan',
    label: 'Plan',
    url: 'https://{s}.tile.openstreetmap.fr/osmfr/{z}/{x}/{y}.png',
    attribution: '© OpenStreetMap France | © OpenStreetMap contributors',
    maxZoom: 20,
  },
  {
    id: 'satellite',
    label: 'Satellite',
    url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
    attribution: 'Tiles © Esri — Source: Esri, Maxar, Earthstar Geographics',
    maxZoom: 19,
  },
  {
    // Carto Dark SANS labels : pas de fond dark français gratuit sans clé, et la
    // variante `dark_all` portait des libellés anglais (incohérent avec l'UI FR).
    // `dark_nolabels` supprime tout texte ; le repère géographique vient des contours
    // de régions (toujours dessinés) et des bulles/labels de valeur de la carte.
    id: 'dark',
    label: 'Sombre',
    url: 'https://{s}.basemaps.cartocdn.com/dark_nolabels/{z}/{x}/{y}{r}.png',
    attribution: '© OpenStreetMap © CARTO',
    maxZoom: 20,
  },
];

const byId = new Map(BASEMAPS.map((b) => [b.id, b]));

/** Fond par id, repli sur le défaut si inconnu. */
export function getBasemap(id: string | undefined): Basemap {
  return byId.get(id ?? '') ?? byId.get(DEFAULT_BASEMAP)!;
}
